.item {
    border-bottom: 1px solid var(--color-contrast);
}

.trigger {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    padding: var(--spacer-24) 0;
    background: none;
    border: none;
    color: inherit;
    text-align: left;
    font: var(--font-h-24-forma);
    cursor: pointer;
}

.title {
    padding-right: var(--spacer-24);
}

.toggle {
    position: relative;
    width: 0.67em;
    height: 0.67em;
    flex: none;

    &::before,
    &::after {
        content: "";
        position: absolute;
        inset: 50% 0 auto;
        height: 1px;
        background: currentColor;
    }

    &::after {
        transform: rotate(90deg);
    }

    .item[data-expanded] & {
        &::after {
            transform: rotate(0deg);
        }
    }
}

.panel {
    display: grid;
    grid-template-rows: 0fr;
    font: var(--font-p-16);

    &[aria-hidden="false"] {
        grid-template-rows: 1fr;
    }
}

.panelInner {
    overflow: hidden;
    padding: 0 0 var(--spacer-24);
    opacity: 0;
}

.panel[aria-hidden="false"] .panelInner {
    opacity: 1;
}

@media (prefers-reduced-motion: no-preference) {
    .toggle::before,
    .toggle::after {
        transition: transform 200ms ease;
    }

    .panel {
        transition: grid-template-rows 200ms ease;
    }

    .panelInner {
        transition: opacity 150ms ease 200ms;
    }

    .panel[aria-hidden="true"] {
        transition-delay: 200ms;

        .panelInner {
            transition-delay: 0ms;
        }
    }
}
